/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Load_From_Hr_EstimatedInputs */

const en_ui_more_stats_load_from_hr_estimated = /** @type {(inputs: Ui_More_Stats_Load_From_Hr_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From heart rate · threshold estimated`)
};

const de_ui_more_stats_load_from_hr_estimated = /** @type {(inputs: Ui_More_Stats_Load_From_Hr_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Puls · Schwelle geschätzt`)
};

/**
* | output |
* | --- |
* | "From heart rate · threshold estimated" |
*
* @param {Ui_More_Stats_Load_From_Hr_EstimatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_load_from_hr_estimated = /** @type {((inputs?: Ui_More_Stats_Load_From_Hr_EstimatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Load_From_Hr_EstimatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_load_from_hr_estimated(inputs)
	return de_ui_more_stats_load_from_hr_estimated(inputs)
});